"use client";

import { motion } from "framer-motion";
import Image from "next/image";

// Paste the output from generateBlur.ts here
const LOGO_BLUR =
  "data:image/webp;base64,UklGRhwAAABXRUJQVlA4IBQAAAAwAQCdASoIAAQAAgA4AAYAAAMAuVORK5CYII=";

export default function Loading() {
  const logoUrl = `https://assetsvilva.blr1.cdn.digitaloceanspaces.com/store/${process.env.NEXT_PUBLIC_STORE_CODE}/favpng.png`;

  return (
    <div className="flex h-screen w-full items-center justify-center bg-white">
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: [1, 1.1, 1] }}
        transition={{
          opacity: { duration: 0.3 },
          scale: { duration: 1.5, repeat: Infinity, ease: "easeInOut" },
        }}
        className="relative h-[130px] w-[130px]"
      >
        <Image
          src={logoUrl}
          alt="Loading..."
          fill
          sizes="130px"
          quality={85}
          priority
          placeholder="blur"
          blurDataURL={LOGO_BLUR}
          className="object-contain"
          onError={(e) => {
            (e.target as HTMLImageElement).src =
              "https://vilva-backup.blr1.digitaloceanspaces.com/vilvabusiness/common%20files/empty-logowebp.webp";
          }}
        />
      </motion.div>
    </div>
  );
}